import React from 'react';

const HighlightComponent = ({ text, query, maxWidth }) => {
	if (!text) return null;

	const wrapperStyle = maxWidth
		? {
				maxWidth,
				overflow: 'hidden',
				textOverflow: 'ellipsis',
				whiteSpace: 'nowrap',
				display: 'inline-block',
				verticalAlign: 'top',
				background: 'transparent',
		  }
		: {};

	if (!query) {
		return (
			<span style={wrapperStyle} title={text}>
				{text}
			</span>
		);
	}

	const matchStart = text.toLowerCase().indexOf(query.toLowerCase());
	if (matchStart < 0) {
		return (
			<span style={wrapperStyle} title={text}>
				{text}
			</span>
		);
	}

	return (
		<span style={wrapperStyle} title={text}>
			{text.substring(0, matchStart)}
			<span style={{ background: '#f2f2ab' }}>
				{text.substring(matchStart, matchStart + query.length)}
			</span>
			{text.substring(matchStart + query.length)}
		</span>
	);
};

export default HighlightComponent;



// WEBPACK FOOTER //
// ./src/components/highlightComponent.js